
import React, { Component } from "react";
import {
    GetGHGEstimationUrl
} from "../../config";


class RetriggerEmissionCalculations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jwtToken: "",
            organizationId: "",
        };
    }

    componentDidMount() { }

    render() {
        const { classes } = this.props;
        const src = GetGHGEstimationUrl() + "admin/emission-calculations-retrigger?accessToken=" + localStorage.opsToken;
        ///listing?accessToken=" + localStorage.opsToken;
        return (
            <iframe title="Retrigger Emission Calculations"
                id="Retrigger Emission Calculations"
                src={src}
                style={{ width: "100%", height: "100vh", border: "none" }}
            />
        )
    }
};

export default RetriggerEmissionCalculations;
